import { useCallback, useEffect } from 'react';

type Key = 'Escape' | 'Enter';
export function useOnKeyDown(keys: Key[], callback?: () => void) {
  const onKeyDown = useCallback(
    (event: KeyboardEvent) => {
      for (const key of keys) {
        if (event.key === key) callback?.();
      }
    },
    [keys, callback],
  );

  useEffect(() => {
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  });
}

export function useOnEscape(callback?: () => void) {
  useOnKeyDown(['Escape'], callback);
}
export function useOnEnter(callback?: () => void) {
  useOnKeyDown(['Enter'], callback);
}
